const allVendors = ["KNB", "TM", "PV", "TMFA", "TM Vads Lyfe", "PLB"];

// const TM_VENDORS = ["TM", "TMFA", "TM Vads Lyfe"];

const TM_VENDORS = ["TM"];

const REPORT_VENDORS = ["KNB", "TM", "PV", "PLB"];

module.exports = { allVendors, TM_VENDORS, REPORT_VENDORS };
